/* eslint-disable react/display-name */
import { debounce, isEmpty } from 'lodash';
import Checkbox from '@shared/component/Checkbox';
import {
    DateFormatPicker,
    TextTruncate,
    actionsPermissionValidator,
    checkUrlString,
    ActionValues,
} from '@utils/static/commonUtils';
import React, { useEffect, useState, useImperativeHandle, forwardRef, useRef } from 'react';
import { IconContext } from 'react-icons';
import { AiFillLeftCircle, AiFillRightCircle } from 'react-icons/ai';
import ReactPaginate from 'react-paginate';
import { NavLink } from 'react-router-dom';
import StatusDropDown from './StatusDropDown';
import moment from 'moment';
import { TbFileExport } from 'react-icons/tb';
import { TIMEOUT } from 'dns';
import GlobalSearch from './GlobalSearch';
import { default as loader } from '../../assets/images/loaderanimated.svg';
import BulkUpload from './BulkUpload';
import ReactStars from 'react-rating-stars-component';
import { useLocalStorage } from '@shared/auth/useLocalStorage';
import { useNavigate } from 'react-router-dom';
import BulkUploadTransportAppUser from './BulkUploadTransportAppUser';

const Lists = forwardRef((props: any, ref) => {
    const { getItem } = useLocalStorage();
    const navigate = useNavigate();

    const childRef: any = useRef(null);
    const [headers, setHeaders] = useState<any>([]);
    const [list, setlist] = useState([]);
    const [userLocal, setLocalUser] = useState<User | null>(null);
    const [page, setPage] = useState(1);
    const [deleteshow, setDeleteShow] = useState(false);
    const [deleteIds, setDeleteIds] = useState<number[]>([]);
    const [allChecked, setallChecked] = useState(false);
    const [search, setSearch] = useState('');
    const recordPerPage: any = process.env.REACT_APP_RECORD_PER_PAGE;
    const [originalData, setOriginalData] = useState<any>({});
    const [showLoader, setshowLoader] = useState(false);
    const [listCount, setlistCount] = useState(false);
    const [showHideModel, setShowHideModel] = useState(false);
    const [showCheckBox, setShowCheckBox] = useState(false);
    const [tableData, setTableData] = useState([]);
    // const [searchText, setSearchText] = useState<any>(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [showDelete, setShowDelete] = useState(props.showDeleteBtn == false ? false : true);

    // useEffect(()=>{if(props?.showDeleteBtn == true){setShowDelete(props.showDeleteBtn)}}, [props.showDeleteBtn])

    const handelModel = (flag: boolean) => {
        try {
            props.handelModel(flag);
        } catch (error) { }
    };
    const hasDemandsBidsPermission = userLocal?.user_role.user_permissions.some(
        permission => permission.name === 'Demands/Bids/Transporter',
    );

    const hasDemandsBidsPermissionOther = userLocal?.user_role.user_permissions.some(
        permission => permission.name === 'Demands/Bids/Other',
    );

    // Handle  filter model

    const handelFilterModal = (flag: boolean) => {
        try {
            props.handelFilterModal(flag);
        } catch (error) { }
    };

    useEffect(() => {
        if (getItem('user') !== null) {
            const userStr = getItem('user');
            const user = JSON.parse(userStr!);
            setLocalUser(user);
        }
    }, []);

    const handleSelectAll = () => {
        try {
            setallChecked(!allChecked);
            setDeleteIds(originalData?.data?.map((i: any) => i.id));
            if (allChecked) {
                setDeleteIds([]);
            }
        } catch (error) { }
    };

    useEffect(() => { }, [deleteIds]);

    const handleClick = (e: any) => {
        try {
            const { id, checked } = e.target;
            const idd = parseInt(id, 10);

            setDeleteIds(prevDeleteIds => {
                const updatedDeleteIds = checked ? [...prevDeleteIds, idd] : prevDeleteIds.filter(item => item !== idd);

                if (originalData.data.length === updatedDeleteIds.length) {
                    setallChecked(true);
                } else {
                    setallChecked(false);
                }

                return updatedDeleteIds;
            });
        } catch (error) { }
    };

    useEffect(() => {
        if (props?.data?.length == 0) {
            setlistCount(true);
        }
        setshowLoader(false);
        // if (!actionsPermissionValidator(location.pathname, ActionValues.Edit)) {
        //     const { action, ...updatedHeaders } = props?.headers;
        //     console.log(updatedHeaders, 'updatedHeaders');
        //     setHeaders(updatedHeaders);
        //     setOriginalData({ headers: props?.headers, data: props?.data });
        //     return;
        // }
        // console.log(props?.headers, 'headers');
        setHeaders(props?.headers);

        setOriginalData({ headers: props?.headers, data: props?.data });
    }, [props?.data, props?.headers]);

    const getPage = (e: any) => {
        try {
            setPage(e + 1);
            setCurrentPage(e);
            if (search?.trim().length > 0) {
                props.searchItem(search.trim(), e + 1);
            } else {
                props.callPagination(e + 1);
            }
            setDeleteShow(false);
            setDeleteIds([]);
            setallChecked(false);
        } catch (error) { }
    };

    const onClickDeleteBtn = async () => {
        try {
            setShowCheckBox(true);
        } catch (err) { }
    };

    const onClickCancelBtn = async () => {
        try {
            setallChecked(false);
            setDeleteIds([]);
            setShowCheckBox(false);
        } catch (err) {
            console.log(err);
        }
    };

    const callDelete = () => {
        try {
            props.getDeleteIds(deleteIds);

            setallChecked(false);
            setDeleteShow(false);
            setDeleteIds([]);
            setShowCheckBox(false);
        } catch (error) { }
    };

    const getSearchData = search => {
        try {
            setlist([]);
            setSearch(search);
            if (search?.trim().length > 0) {
                props.searchItem(search.trim());
            } else {
                props.callPagination(1);
                setCurrentPage(0);
            }

            setDeleteShow(false);
            setDeleteIds([]);
            setallChecked(false);
            setshowLoader(true);
        } catch (error) { }
    };

    const manipulateItem = (item, key) => {
        try {
            const a = key.split('.');
            let b: any = null;
            for (let i = 0; i < a.length; i++) {
                if (b) {
                    b = b[a[i]];
                } else {
                    b = item[a[i]];
                }
            }
            // console.log('----', b);
            return b;
        } catch (error) {
            console.log({ error });
        }
    };

    function showArrayValues(arr, limit) {
        if (Array.isArray(arr)) {
            // const uniqueValues = Array.from(new Set(arr));
            // Remove duplicate values
            if (arr.length > 2) {
                const limitedValues = arr.slice(0, limit);
                return limitedValues.join(',') + '...';
            }
            const limitedValues = arr.slice(0, limit); // Get the first 'limit' values

            return limitedValues.join(',');
        } else {
            return ''; // Return an empty string in case of an error
        }
    }
    const checkResnedValid = item => {
        let status = false;
        try {
            const date1 = moment(item.createdAt);
            const date2 = moment();
            const daysDifference = date2.diff(date1, 'hours');
            if (
                isEmpty(item?.documents?.pincode) &&
                isEmpty(item?.documents?.aadharNo) &&
                isEmpty(item?.documents?.panNo) &&
                item.documentStatus == 'Pending' &&
                daysDifference > 48
            ) {
                status = true;
            }
            return status;
        } catch (error) {
            return status;
        }
    };

    const checkDemandCutoffPassed = item => {
        if (userLocal?.user_role?.name == 'Super Admin') {
            return false;
        } else {
            const cdate = moment();
            const cutOffDate = moment(item.cutOffTime);
            // console.log('------', item, item.cutOffTime, cutOffDate.isBefore(cdate));
            return cdate.isBefore(cutOffDate);
        }
    };

    // const checkDemandCutoffPassedAdmin = item => {
    //     if (userLocal?.user_role?.name == 'Super Admin' && item.status == 'pending') {
    //         const cdate = moment();
    //         const cutOffDate = moment(item.cutOffTime);
    //         console.log('------', item.id, item.cutOffTime, cutOffDate.isBefore(cdate));
    //         return cutOffDate.isBefore(cdate);
    //     } else {
    //         return false
    //     }
    // };
    const checkDemandCutoffPassedAdmin = (item) => {
        const isSuperAdmin = userLocal?.user_role?.name === 'Super Admin';
        const currentDate = moment();

        if (isSuperAdmin && item.status === 'pending') {
            const cutOffDate = moment(item.cutOffTime);
            return cutOffDate.isBefore(currentDate); // true if cutoff already passed
        }

        else if (isSuperAdmin && item.status === 'completed') {
            const pickUpDate = moment(item.pickUpDate);
            return pickUpDate.isAfter(currentDate); // true if pickup is in the future
        }

        return false;
    };



    const gotToBidsList = link => {
        try {
            navigate(link);
        } catch (error) { }
    };

    // pass data to parents
    const renderTd = (item, key, cellIndex) => {
        const keyData = manipulateItem(item, key);



        let appUserName;
        if (key === 'app_users') {
            appUserName = keyData;
        }

        const passData = () => {
            props.sendData(appUserName);
        };

        const actionKey =
            key === 'action' ||
                key === 'demandTransporterAction' ||
                key === 'actionSignUpReq' ||
                key === 'demandOtherAction' ||
                key === 'othersAction' ||
                key === 'transporterAction'
                ? 'action'
                : null;

        // console.log('----', key, actionKey, (actionKey == 'action') ? `pinned-column` : 'p-2')
        const names =
            key === 'app_users' && Array.isArray(keyData)
                ? keyData
                    .slice(0, 2)
                    .map(person => person.name)
                    .join(', ')
                : keyData;
        return (
            <React.Fragment>
                <td
                    key={cellIndex}
                    data-bs-toggle="tooltip"
                    title={keyData ? (key == 'app_users' ? '' : keyData) : ''}
                    className={actionKey == 'action' ? `pinned-column` : 'p-2'}
                >

                    {key === 'status' && (
                        <div
                            className={
                                item.status === 'active'
                                    ? 'dropdown dropdown_status_box'
                                    : item.status === 'completed'
                                        ? 'status_box_Disabled'
                                        : 'dropdown dropdown_status_box inactive_status_box'
                            }
                        >
                            {actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                item.status === 'completed' || item.status === 'pending' ? (
                                    <span className="cell_center text-center text-secondary">{item?.status}</span>
                                ) : item?.isMobileDelete === true ? (
                                    <span className="cell_center text-center text-secondary">Deleted</span>
                                ) : (
                                    <>
                                        <button
                                            className="btn btn-secondary dropdown-toggle capitalize"
                                            type="button"
                                            id={`dropdownMenuButton-${item.id}`}
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {item?.status}
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${item.id}`}>
                                            <li>
                                                <a
                                                    className={
                                                        item.status === 'active'
                                                            ? 'dropdown-item active'
                                                            : 'dropdown-item'
                                                    }
                                                    href="javascript:void(0)"
                                                    onClick={() => {
                                                        props.updateStatus(item, 'active', item.id, page, search);
                                                    }}
                                                >
                                                    Active
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className={
                                                        item.status === 'inactive'
                                                            ? 'dropdown-item active'
                                                            : 'dropdown-item'
                                                    }
                                                    href="javascript:void(0)"
                                                    onClick={() => {
                                                        props.updateStatus(item, 'inactive', item.id, page, search);
                                                    }}
                                                >
                                                    Inactive
                                                </a>
                                            </li>
                                        </ul>
                                    </>
                                )
                            ) : (
                                <>
                                    <button className="capitalize text-center" type="button" disabled>
                                        {item?.status}
                                    </button>
                                </>
                            )}
                        </div>
                    )}
                    {actionsPermissionValidator(location.pathname, ActionValues.Edit)
                        ? key === 'statusSignUpReq' && <StatusDropDown item={item} updateStatus={props.updateStatus} />
                        : key === 'statusSignUpReq' && <StatusDropDown item={item} disabled={true} />}

                    {key === 'action' && (
                        <div className="d-flex justify-content-left justifyCenter">
                            {actionsPermissionValidator(location.pathname, ActionValues.Edit) && (
                                <button
                                    className="btn blue_btn custom_btn"
                                    onClick={() => {
                                        props.getById(item.id);
                                    }}
                                >
                                    <img className="img-fluid" src="assets/images/edit.svg" alt="" /> Edit
                                </button>
                            )}
                        </div>
                    )}
                    {key === 'demandTransporterAction' && (
                        <div className="last_edit_box">
                            <>
                                {item?.status !== 'completed' &&
                                    actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                    <a
                                        className="btn blue_btn custom_btn"
                                        href="javascript:void(0)"
                                        onClick={() => {
                                            props.getById(item?.id);
                                        }}
                                    >
                                        <img className="img-fluid" src="assets/images/edit.svg" alt="" /> Edit
                                    </a>
                                ) : (
                                    <>
                                        <a
                                            className="btn blue_btn custom_btn"
                                            href="javascript:void(0)"
                                            onClick={() => {
                                                props.getById(item?.id);
                                            }}
                                        >
                                            <i className={`fa fa-eye`} aria-hidden="false"></i> View
                                        </a>
                                    </>
                                )}
                            </>
                            <>
                                &nbsp;
                                {hasDemandsBidsPermission ? (
                                    <button
                                        onClick={() =>
                                            gotToBidsList(
                                                `/home/bids/transporter/${item.id}/${item?.from?.city +
                                                '-' +
                                                item?.to?.city}`,
                                            )
                                        }
                                        className="btn bidsblue_btn custom_btn"
                                        disabled={checkDemandCutoffPassed(item)}
                                    >
                                        <img
                                            className="img-fluid "
                                            style={{ width: '18px' }}
                                            src="assets/images/bids.png"
                                            alt=""
                                        />{' '}
                                        {`Bids (${item?.bids?.length || 0})`}
                                    </button>
                                ) : (
                                    ''
                                )}
                            </>
                        </div>
                    )}
                    {key === 'demandOtherAction' && (
                        <div className="last_edit_box">
                            {item.status !== 'completed' &&
                                actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                <a
                                    className="btn blue_btn custom_btn"
                                    href="javascript:void(0)"
                                    onClick={() => {
                                        props.getById(item.id);
                                    }}
                                >
                                    <img className="img-fluid" src="assets/images/edit.svg" alt="" /> Edit
                                </a>
                            ) : (
                                <>
                                    {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                                    <a
                                        className="btn blue_btn custom_btn"
                                        href="javascript:void(0)"
                                        onClick={() => {
                                            props.getById(item.id);
                                        }}
                                    >
                                        <i className={`fa fa-eye`} aria-hidden="false"></i> View
                                    </a>
                                </>
                            )}
                            &nbsp;
                            {hasDemandsBidsPermissionOther ? (
                                <button
                                    onClick={() => gotToBidsList(`/home/bids/others/${item.id}/${item?.item?.name}`)}
                                    className="btn bidsblue_btn custom_btn"
                                    disabled={checkDemandCutoffPassed(item)}
                                >
                                    <img
                                        className="img-fluid "
                                        style={{ width: '18px' }}
                                        src="assets/images/bids.png"
                                        alt=""
                                    />{' '}
                                    {`Bids (${item?.bids?.length || 0})`}
                                </button>
                            ) : (
                                ''
                            )}
                        </div>
                    )}
                    {(key === 'othersAction' || key === 'transporterAction') && (
                        <div className="d-flex justify-content-left justifyCenter">
                            {item?.isMobileDelete === false &&
                                actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                <>
                                    <button
                                        className="btn blue_btn custom_btn"
                                        onClick={() => {
                                            props.getById(item.id, 'edit');
                                        }}
                                    >
                                        <img className="img-fluid" src="assets/images/edit.svg" alt="" /> Edit
                                    </button>
                                </>
                            ) : (
                                ''
                            )}
                            &nbsp;
                            <button
                                className="btn blue_btn custom_btn"
                                style={{ backgroundColor: '#022d4a', color: 'white' }}
                                onClick={() => {
                                    props.getById(item.id, 'view');
                                }}
                            >
                                View
                            </button>
                        </div>
                    )}
                    {key === 'actionSignUpReq' && (
                        <div className="d-flex justify-content-left justifyCenter">
                            <a
                                className="btn bidsblue_btn custom_btn"
                                href="javascript:void(0)"
                                onClick={() => {
                                    props.getById(item.id);
                                }}
                            >
                                View
                            </a>
                            {props?.hideCopy ? (
                                ''
                            ) : (
                                <a
                                    className="btn bidsblue_btn custom_btn"
                                    href="javascript:void(0)"
                                    onClick={() => {
                                        props.Copy(item?.documents?.link);
                                    }}
                                >
                                    Copy
                                </a>
                            )}

                            {actionsPermissionValidator(location.pathname, ActionValues.Edit)
                                ? checkResnedValid(item) && (
                                    <a
                                        className="btn bidsblue_btn custom_btn"
                                        href="javascript:void(0)"
                                        onClick={() => {
                                            props.resendLink(item);
                                        }}
                                    >
                                        Resend Link
                                    </a>
                                )
                                : ''}
                        </div>
                    )}
                    {key === 'penalisedStatus' && (
                        <>
                            {item?.penalisedStatus === null ? (
                                <>
                                    <div className="d-flex justify-content-center justifyCenter">
                                        <button
                                            className="btn blue_btn custom_btn"
                                            onClick={() => {
                                                props.getById(item.id, 'waive');
                                            }}
                                        >
                                            Waive Off
                                        </button>
                                        &nbsp;
                                        <button
                                            className="btn blue_btn custom_btn"
                                            style={{
                                                backgroundColor: '#022d4a',
                                                color: 'white',
                                            }}
                                            onClick={() => {
                                                props.getById(item.id, 'penalised');
                                            }}
                                        >
                                            Penalised
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <button
                                    className="btn blue_btn custom_btn"
                                    style={{ backgroundColor: '#f3f4f5', color: 'gray' }}
                                >
                                    {item?.penalisedStatus === 'penalised' ? 'Penalised' : 'Waived Off'}
                                </button>
                            )}
                        </>
                    )}
                    {key === 'items' && (item[key]?.length || 0)}
                    {key === 'id' && props.from == 'transporter' && <span
                        onClick={() => {
                            if (checkDemandCutoffPassedAdmin(item)) {
                                props?.handleDemandId(keyData);
                                props?.handleBidListingModal(true);
                            }
                        }}

                        style={
                            checkDemandCutoffPassedAdmin(item) ?
                                { color: '#034f81', cursor: 'pointer', textDecoration: 'underline' }
                                : {}
                        }
                    >

                        {keyData}

                    </span>}
                    {key === 'category' && (item[key]?.name || item[key])}
                    {key === 'rating' && (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <ReactStars
                                count={5}
                                value={item.rating}
                                size={15}
                                isHalf={true}
                                emptyIcon={<i className="fa fa-star" style={{ color: 'green' }}></i>}
                                halfIcon={<i className="fa fa-star-half-alt" style={{ color: 'white' }}></i>}
                                fullIcon={<i className="fa fa-star" style={{ color: 'white' }}></i>}
                                activeColor="#FFA800"
                                edit={false}
                            />

                            {/* {'|' + item?.rating_appUsers?.length + ' Reviews'} */}
                        </div>
                    )}
                    {key === 'deliveryDate' && DateFormatPicker(item[key], 'DD-MMM-YYYY hh:mm A')}
                    {key === 'createdAt' && DateFormatPicker(item[key], 'DD-MMM-YYYY hh:mm A')}
                    {key === 'expectedDeliveryDate' && DateFormatPicker(item[key], 'DD-MMM-YYYY hh:mm A')}
                    {key === 'actualDeliveryDate' && (keyData ? DateFormatPicker(item[key], 'DD-MMM-YYYY') : '-')}
                    {key === 'deliveredDeliveryDate' && (keyData ? DateFormatPicker(item[key], 'DD-MMM-YYYY') : '-')}
                    {key === 'pickUpDate' && DateFormatPicker(item[key], 'DD-MMM-YYYY hh:mm A')}
                    {key === 'demand.pickUpDate' && DateFormatPicker(keyData, 'DD-MMM-YYYY')}
                    {key === 'appUserName' && showArrayValues(item['appUserName'], 2)}
                    {key === 'demand.deliveryDate' && (keyData ? DateFormatPicker(keyData, 'DD-MMM-YYYY') : '')}
                    {key === 'demand.createdAt' && (keyData ? DateFormatPicker(keyData, 'DD-MMM-YYYY') : '')}
                    {key === 'demands_other.createdAt' && (keyData ? DateFormatPicker(keyData, 'DD-MMM-YYYY') : '')}
                    {key === 'app_user.name' && keyData}
                    {key === 'nickName' && (keyData ? keyData : '_')}
                    {key === 'area' && (keyData ? keyData : '_')}


                    <a>
                        {key === 'app_users' && (
                            <>
                                {names}
                                <span
                                    onClick={() => passData()}
                                    style={{ color: '#034f81', cursor: 'pointer', textDecoration: 'underline' }}
                                >
                                    {'  '}
                                    {appUserName?.length > 2 ? <small>view more...</small> : ''}
                                </span>
                            </>
                        )}
                    </a>

                    {/* {key === 'roleName' && TextTruncate(item['name'], 70, true)}
                    {/* {key === 'roleName' && TextTruncate(item['name'], 70, true)}
                    {key === 'UserName' && TextTruncate(item['name'], 30, true)} */}
                    {key === 'message' && TextTruncate(keyData, 20, true)}
                    {key === 'mid.city' && (keyData ? keyData : '_')}
                    {/* {key === 'deliveryStatus' ? (
                    item?.deliveryStatus === 'notArrived' ? (
                        <span className="text-danger ">
                            <b>Not Arrived</b>
                        </span>
                    ) : (
                        <span className="text-success ">
                            <b>Arrived</b>
                        </span>
                    )
                ) : (
                    ''
                )} */}

                    {key === 'deliveryStatus' && keyData}

                    {(key === 'other_document.gstDoc' ||
                        key === 'other_document.panDoc' ||
                        key === 'other_document.aadharDoc' ||
                        key === 'other_document.idProof' ||
                        key === 'document_transporter.gstDoc' ||
                        key === 'document_transporter.panDoc' ||
                        key === 'document_transporter.idProof' ||
                        key === 'documents.gstDoc' ||
                        key === 'documents.panDoc' ||
                        key === 'documents.idProof' ||
                        key === 'other_document.otherDoc') &&
                        keyData && (
                            <a
                                target="_blank"
                                className="text-primary"
                                rel="noreferrer"
                                href={`${process.env.REACT_APP_API_BASE}${checkUrlString(keyData)}`}
                            >
                                <u>View</u>
                            </a>
                        )}
                    {(key === 'companyname' || key === 'name' || key === 'remark') && TextTruncate(keyData, 40, true)}
                    {key !== 'status' &&
                        // key !== 'appUserName' &&
                        key !== 'nickName' &&
                        (key !== 'id' || props.from !== 'transporter') &&
                        key !== 'demands_other.createdAt' &&
                        key !== 'area' &&
                        key !== 'mid.city' &&
                        key !== 'app_users' &&
                        key !== 'createdAt' &&
                        key !== 'message' &&
                        key !== 'appUserName' &&
                        key !== 'deliveredDeliveryDate' &&
                        key !== 'rating' &&
                        key !== 'action' &&
                        key !== 'penalisedStatus' &&
                        key !== 'items' &&
                        key !== 'expectedDeliveryDate' &&
                        key !== 'actualDeliveryDate' &&
                        key !== 'deliveryStatus' &&
                        key !== 'pickUpDate' &&
                        key !== 'deliveryDate' &&
                        key !== 'other_document.gstDoc' &&
                        key !== 'other_document.panDoc' &&
                        key !== 'other_document.aadharDoc' &&
                        key !== 'other_document.idProof' &&
                        key !== 'other_document.otherDoc' &&
                        key !== 'document_transporter.gstDoc' &&
                        key !== 'document_transporter.panDoc' &&
                        key !== 'document_transporter.idProof' &&
                        key !== 'documents.gstDoc' &&
                        key !== 'documents.panDoc' &&
                        key !== 'documents.idProof' &&
                        key !== 'companyname' &&
                        key !== 'name' &&
                        key !== 'remark' &&
                        key !== 'app_user.name' &&
                        key !== 'demand.pickUpDate' &&
                        key !== 'demand.deliveryDate' &&
                        key !== 'demand.createdAt' &&
                        key !== 'app_user.name' &&
                        // key !== 'roleName' &&
                        // key !== 'UserName' &&
                        keyData}
                </td>
            </React.Fragment >
        );
    };

    const listLog = (originalData?.data || []).map((item: any, index) => {
        return (
            <tr key={index}>
                {showCheckBox ? (
                    <td>
                        <Checkbox
                            key={item.id}
                            type="checkbox"
                            name={`${item.id}-checkbox`}
                            id={item.id}
                            handleClick={handleClick}
                            isChecked={deleteIds.includes(item.id)}
                        />
                    </td>
                ) : (
                    <></>
                )}

                {Object.keys(props.headers).map((key, cellIndex) => renderTd(item, key, cellIndex))}
            </tr>
        );
    });

    const clearSearchBox = flag => {
        if (!flag) {
            setCurrentPage(0);
        }

        childRef.current.clearSearchBox();
    };

    const resetPagination = () => {
        setCurrentPage(0);
    };

    useImperativeHandle(ref, () => ({
        clearSearchBox,
        resetPagination,
    }));

    return (
        <>
            {props.showFilter ? (
                <></>
            ) : (
                <div className="table_filter_box_cover">
                    <div className="row">
                        <div className="col-sm-7">
                            <div className="table_filter_inner_box">
                                <GlobalSearch
                                    ref={childRef}
                                    helperText={props.helperText || null}
                                    getSearchData={getSearchData}
                                />
                            </div>
                        </div>
                        <div className="col-sm-5 text-end">
                            {props?.type == 'add+delete' ? (
                                <>
                                    <div
                                        className="table_add_inner_box add_box"
                                        style={deleteshow ? { display: 'none' } : { display: 'flex' }}
                                    >
                                        {actionsPermissionValidator(location.pathname, ActionValues.View) &&
                                            props.showFilterButton && (
                                                <button
                                                    className="btn custom_btn fill_btn with_icon position-relative"
                                                    style={{ marginRight: '20px' }}
                                                    onClick={() => handelFilterModal(true)}
                                                    type="button"
                                                >
                                                    <span className="mat_icon material-symbols-outlined">
                                                        filter_alt
                                                    </span>
                                                    &nbsp;{props.filterText}
                                                    {props?.filterDataObj &&
                                                        Object.keys(props.filterDataObj).length > 0 && (
                                                            <span className="position-absolute top-0 start-100 translate-middle p-2 bg-primary border border-light rounded-circle">
                                                                <span className="visually-hidden">New alerts</span>
                                                            </span>
                                                        )}
                                                </button>
                                            )}

                                        {actionsPermissionValidator(location.pathname, ActionValues.Add) ? (
                                            <>
                                                <a
                                                    className="btn custom_btn fill_btn with_icon"
                                                    href="javascript:void(0)"
                                                    onClick={() => handelModel(true)}
                                                >
                                                    <span className="mat_icon material-symbols-outlined">add</span>Add{' '}
                                                    {props.addUpdateText}
                                                </a>

                                                {props.from === 'transporter' ||
                                                    props.from === 'others' ||
                                                    props.from === 'transporter_app_user' ? (
                                                    <>
                                                        <a
                                                            className="btn custom_btn unfillbulk_btn  with_icon"
                                                            href="javascript:void(0)"
                                                            onClick={() => setShowHideModel(true)}
                                                        >
                                                            <span className="material-symbols-outlined">upload</span>
                                                            <span
                                                                className="d-flex"
                                                                style={{
                                                                    justifyContent: 'space-between',
                                                                    flexDirection: 'row',
                                                                }}
                                                            >
                                                                Bulk Upload{' '}
                                                            </span>
                                                        </a>
                                                        {/* {props.showFilterButton && (
                                                            <>
                                                                <button
                                                                    className="btn custom_btn fill_btn with_icon position-relative"
                                                                    style={{ marginRight: '20px' }}
                                                                    onClick={() => handelFilterModal(true)}
                                                                    type="button"
                                                                >
                                                                    <span className="mat_icon material-symbols-outlined">
                                                                        filter_alt
                                                                    </span>{' '}
                                                                    &nbsp;{props.filterText}
                                                                    {props?.filterDataObj &&
                                                                        Object.keys(props.filterDataObj).length > 0 && (
                                                                            <span className="position-absolute top-0 start-100 translate-middle p-2 bg-primary border border-light rounded-circle">
                                                                                <span className="visually-hidden">
                                                                                    New alerts
                                                                                </span>
                                                                            </span>
                                                                        )}
                                                                </button>
                                                            </>
                                                        )} */}
                                                    </>
                                                ) : (
                                                    ''
                                                )}
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {actionsPermissionValidator(location.pathname, ActionValues.Delete) &&
                                            showDelete ? (
                                            <a
                                                className="btn custom_btn border_btn with_icon add_box_delete_btn"
                                                href="javascript:void(0)"
                                                onClick={() => {
                                                    setDeleteShow(true);
                                                    onClickDeleteBtn();
                                                }}
                                            >
                                                <span className="mat_icon material-symbols-outlined">delete</span>Delete{' '}
                                                {props.addUpdateText}
                                            </a>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                    <div
                                        className="table_add_inner_box delete_box"
                                        style={deleteshow ? { display: 'flex' } : { display: 'none' }}
                                    >
                                        {deleteIds?.length > 0 && (
                                            <a
                                                className="btn custom_btn orange_btn with_icon"
                                                href="javascript:void(0)"
                                                data-bs-toggle="modal"
                                                data-bs-target="#conform_delete_box"
                                            >
                                                <span className="mat_icon material-symbols-outlined">delete </span>
                                                Delete {props.addUpdateText}
                                            </a>
                                        )}

                                        <a
                                            className="btn custom_btn border_btn with_icon delete_box_delete_btn"
                                            href="javascript:void(0)"
                                            onClick={() => {
                                                setDeleteShow(false);
                                                onClickCancelBtn();
                                            }}
                                        >
                                            Cancel
                                        </a>
                                    </div>
                                </>
                            ) : (
                                ''
                            )}
                            {props.type == 'report' && props?.showFilterButton && (
                                <>
                                    {props?.showFilterButton && (
                                        <>
                                            {/* <a
                                                className="btn custom_btn fill_btn with_icon"
                                                href="javascript:void(0)"
                                                style={{ marginRight: '20px' }}
                                                onClick={() => handelFilterModal(true)}
                                            >
                                                <span className="mat_icon material-symbols-outlined">filter</span>
                                                &nbsp;{props.filterText}
                                            </a> */}

                                            <button
                                                className="btn custom_btn fill_btn with_icon position-relative"
                                                style={{ marginRight: '20px' }}
                                                onClick={() => handelFilterModal(true)}
                                                type="button"
                                            >
                                                <span className="mat_icon material-symbols-outlined">filter_alt</span>{' '}
                                                &nbsp;{props.filterText}
                                                {props?.filterDataObj && Object.keys(props.filterDataObj).length > 0 && (
                                                    <span className="position-absolute top-0 start-100 translate-middle p-2 bg-primary border border-light rounded-circle">
                                                        <span className="visually-hidden">New alerts</span>
                                                    </span>
                                                )}
                                            </button>
                                        </>
                                    )}
                                </>
                            )}
                            {props.type == 'report' && props.data?.length > 0 && (
                                <>
                                    <a
                                        className="btn custom_btn border_btn with_icon add_box_delete_btn"
                                        href="javascript:void(0)"
                                        title={props?.toolTipDescription ? props?.toolTipDescription : ""}
                                        onClick={() => {
                                            props.handleExport();
                                        }}
                                    >
                                        <TbFileExport />
                                        <span className="mat_icon material-symbols-outlined"></span> Export
                                    </a>
                                </>
                            )}
                            {props.bulkUpload && (
                                <>
                                    {props.from == 'transporter_app_user' ? (
                                        <BulkUploadTransportAppUser
                                            locationData={props.locationData || null}
                                            category={props.categoryData || null}
                                            userData={props.userData}
                                            type={props.from}
                                            demandType={props.demandType}
                                            showHideModel={showHideModel}
                                            setShowHideModel={setShowHideModel}
                                        />
                                    ) : (
                                        <BulkUpload
                                            locationData={props.locationData || null}
                                            category={props.categoryData || null}
                                            userData={props.userData}
                                            type={props.from}
                                            demandType={props.demandType}
                                            showHideModel={showHideModel}
                                            setShowHideModel={setShowHideModel}
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <div className="table_box_cover">
                <div className="table_box_inner_box">
                    <table
                        id="excel-table"
                        className="dataTable display manage_Penalty_table"
                        style={{ width: '100%' }}
                    >
                        <thead>
                            <tr>
                                {showCheckBox ? (
                                    <th>
                                        <Checkbox
                                            type="checkbox"
                                            name="selectAll"
                                            id="selectAll"
                                            handleClick={handleSelectAll}
                                            isChecked={allChecked}
                                        />
                                    </th>
                                ) : (
                                    <></>
                                )}
                                {Object.keys(headers).map((key, index) => (
                                    <>
                                        {headers[key] == 'Status' ? (
                                            <th key={index} style={{ minWidth: '150px', width: '150px' }}>
                                                {'Status'}
                                            </th>
                                        ) : headers[key] == 'Vendor Rating' || headers[key] == 'Transporter Rating' ? (
                                            <th key={index} style={{ minWidth: '90px', width: '90px' }}>
                                                {headers[key]}
                                            </th>
                                        ) : headers[key] == 'Action' ? (
                                            <th key={index} style={{ width: '200px' }}>
                                                <div className="last_edit_box">{headers[key]}</div>
                                            </th>
                                        ) : (
                                            <th key={index}>{headers[key]}</th>
                                        )}
                                    </>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {originalData?.data?.length > 0 ? (
                                listLog
                            ) : (
                                <tr>
                                    <td
                                        colSpan={Object.keys(props.headers)?.length + 2}
                                        className="text-center textTransformNone"
                                    >
                                        <div className="td-loader-center ">
                                            {showLoader ? (
                                                <>
                                                    <img src={loader} height={25} width={25} />
                                                </>
                                            ) : (
                                                listCount && <>No data found</>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {props.data?.length > 0 && props.recordCount > recordPerPage && (
                    <div className="pageApp">
                        <p>
                            {/* Showing {(page - 1) * recordPerPage + 1} to{' '}
                            {Math.min(page * recordPerPage, props.recordCount)} of{' '} */}
                            <span>Total Record : {props.recordCount}</span>
                        </p>
                        <ReactPaginate
                            forcePage={currentPage}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                            pageClassName={'page-item'}
                            onPageChange={(event: any) => getPage(event.selected)}
                            breakLabel="..."
                            pageCount={Math.ceil(props.recordCount / recordPerPage)}
                            previousLabel={
                                <IconContext.Provider value={{ color: '#B8C1CC', size: '36px' }}>
                                    Back
                                </IconContext.Provider>
                            }
                            nextLabel={
                                <IconContext.Provider value={{ color: '#B8C1CC', size: '36px' }}>
                                    Next
                                </IconContext.Provider>
                            }
                        />
                    </div>
                )}
            </div>

            <div
                className="modal fade"
                tabIndex={-1}
                id="conform_delete_box"
                aria-labelledby="logout_popupLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="logout_popupLabel">
                                Delete
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="model">
                                <div className="text_box">
                                    <h3>Are you sure you want to delete all selected records?</h3>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn red_btn custom_btn"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                    callDelete();
                                }}
                            >
                                Delete
                            </button>
                            <button type="button" className="btn custom_btn border_btn" data-bs-dismiss="modal">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default Lists;
